module.exports = __webpack_public_path__ + "media/stylesheets/botyglot/default-theme/20-static/icons/trash-abfca352711bf441dd212727fc4beace.svg";